module.exports = __webpack_public_path__ + "static/libshare-main.21212ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/products/libshare/libshare-main.png
// module id = 895
// module chunks = 156584495553048